<template>
  <el-dialog
    :visible.sync="disableDialog"
    class="dialog-address"
    width="640px"
    :title="title"
    :close="closeAccountDialog"
  >
    <el-form label-width="110px" :model="queryParams" ref="formRef" :rules="ruleForm">
      <el-form-item label="收货人：" prop="crName">
        <el-input v-model.trim="queryParams.crName"></el-input>
      </el-form-item>
      <el-form-item label="联系电话：" prop="crPhone">
        <el-input  @input.native="onInput" v-model.trim="queryParams.crPhone"></el-input>
      </el-form-item>
      <el-form-item label="收货地址：" :required="true">
        <el-address
          ref="addressRefs"
          :provinceEdit="queryParams.provinceReceiving"
          :city="queryParams.cityReceiving"
          :district="queryParams.districtReceiving"
          @changAddress="changAddress($event)"
        ></el-address>
      </el-form-item>
      <el-form-item label="详细地址：" prop="crAddress">
        <el-input v-model.trim="queryParams.crAddress"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-center">
      <el-button @click="onSubmit" type="primary">提交</el-button>
      <el-button @click="closeAccountDialog">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import address from '@/components/Address/index'
import {
  updateCustomerRecevieInfo,
  customerRecevieInfoAdd
} from '@/api/customer/customerManage'
export default {
  props: ['id'],
  components: {
    'el-address': address
  },
  data () {
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('收货人不能为空'))
      } else {
        callback()
      }
    }
    const checkPhone = (rule, value, callback) => {
      const myreg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/
      if (!myreg.test(value)) {
        callback(new Error('请输入正确的联系方式'))
      } else {
        callback()
      }
    }
    var checkAddress = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('地址不能为空'))
      } else {
        callback()
      }
    }
    return {
      title: '',
      disableDialog: false,
      queryParams: {
        receivePhone: ''
      },
      ruleForm: {
        crName: [{ validator: checkName, trigger: 'blur', required: true }],
        crPhone: [
          {
            validator: checkPhone,
            trigger: 'blur',
            required: true
          }
        ],
        crAddress: [
          { validator: checkAddress, trigger: 'blur', required: true }
        ]
      }
    }
  },
  methods: {
    onInput(e) {
      // 过滤非数字和符号-
      const regName = /^[\d-]+$/
      if (!regName.test(e.target.value)) {
        e.target.value = ''
      } else {
        return true
      }
    },
    // 修改收货人初始化
    onInitial (str, item) {
      this.disableDialog = true
      this.title = str
      if (this.title === '修改收货人') {
        if (item.customerRecevieMobileVoList) {
          item.crPhone = item.customerRecevieMobileVoList[0].crPhone
        }
        this.queryParams = JSON.parse(JSON.stringify(item))
      } else {
        this.queryParams = {
          cbId: this.id,
          provinceReceiving: {},
          cityReceiving: {},
          districtReceiving: {}
        }
      }
    },
    closeAccountDialog () {
      this.$refs.formRef.resetFields()
      this.disableDialog = false
    },
    // 提交
    onSubmit () {
      this.$refs.formRef.validate((valid) => {
        if (valid && this.queryParams.crProvince) {
          if (this.title === '修改收货人') {
            const arrList = [this.queryParams]
            updateCustomerRecevieInfo(arrList).then((res) => {
              if (res.data.code === 200) {
                this.$message.success('编辑成功!')
                this.$emit('getCustomer', this.queryParams)
                this.disableDialog = false
              } else {
                this.$message.error(res.data.msg)
              }
            })
          } else {
            customerRecevieInfoAdd(this.queryParams).then((res) => {
              if (res.data.code === 200) {
                this.$message.success('添加成功')
                this.disableDialog = false
                this.$emit('getCustomer', res.data.obj)
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
        } else {
          this.$message.error('信息未填写完整')
        }
      })
    },
    // 通过省id获取市级
    changAddress (params) {
      this.queryParams.crProvince = params.name
      this.queryParams.crProcode = params.code
    }
  }
}
</script>
